import e from "./MobileHeaderModal.js";
import t, { useState as n } from "react";
import { isNil as r } from "es-toolkit/compat";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
//#region src/components/applicationHeader/MobileAppMenu.tsx
var o = (o) => {
	let { appMenuItems: s, appNavigator: c, homeRoute: l, onToggleAppMenu: u } = o, [d, f] = n(!1), p = () => {
		let e = !d;
		f(e), u(e);
	}, m = !(r(s) && r(c));
	return /* @__PURE__ */ a(t.Fragment, { children: [
		/* @__PURE__ */ a("div", {
			className: "navbar-header min-width-50 padding-5 overflow-hidden position-relative display-flex align-items-center",
			onClick: p,
			children: [/* @__PURE__ */ i("span", {
				className: "navbar-brand height-40 width-40",
				children: !m && l
			}), m && /* @__PURE__ */ i("div", {
				className: "position-absolute right-2 bottom-0 text-color-white rotate-45",
				children: /* @__PURE__ */ i("span", { className: "uikit-icon icon-triangle-right" })
			})]
		}),
		c && /* @__PURE__ */ i(e, {
			show: d,
			modalClassName: "padding-top-25",
			onClose: p,
			children: /* @__PURE__ */ i("div", {
				className: "width-100pct height-100pct",
				children: c
			})
		}),
		s && /* @__PURE__ */ i(e, {
			show: d,
			modalClassName: "padding-15",
			onClose: p,
			children: s.map((e) => /* @__PURE__ */ i("li", {
				role: "presentation",
				children: e.route
			}, `link-icon-${e.key}`))
		})
	] });
};
//#endregion
export { o as default };

//# sourceMappingURL=MobileAppMenu.js.map